export default __webpack_public_path__ + "static/media/tasks-da.60bc7996.png";